// @ts-nocheck

import { request } from '../../../../../../../context';
import type { ApiOptions } from '../../../../../../../context';
import type {
    PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdParam,
    PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdBody,
    BaseResponseVoid,
} from '../../../../../../../types';

/**
 * 启用场景
 *
 * @export
 * @tags 智能陪练-AI输入场景节点配置
 * @link [PUT] /review/intelligentPartner/node/inputSceneConfig/manage/roleEnable/{id}
 * @param id
 */
export function putReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableById(
    data: PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdBody,
    options: ApiOptions<
        PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdParam,
        never
    > & { segments: PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdParam }
): Promise<BaseResponseVoid> {
    return request<
        PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdBody,
        PutReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableByIdParam,
        never
    >('/review/intelligentPartner/node/inputSceneConfig/manage/roleEnable/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putReviewIntelligentPartnerNodeInputSceneConfigManageRoleEnableById',
    });
}

export const meta = [
    {
        tags: ['智能陪练-AI输入场景节点配置'],
        path: '/review/intelligentPartner/node/inputSceneConfig/manage/roleEnable/{id}',
        method: 'put',
    },
];
